import { API_BASE_URL } from "configs/AppConfig";
import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const updateOrgChartDepOrder = createAsyncThunk("updateOrgChartDepOrder", async ({ id, order }) => {
	const token = localStorage.getItem("auth_token");
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};

	const response = await axiosHttp.patch(`${API_BASE_URL}department/order/update?id=${id}`, { order: order }, config);

	return response.data.data;
});

const updateOrgChartDepOrderSlice = createSlice({
	name: "updateOrgChartDepOrder",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(updateOrgChartDepOrder.pending, (state, action) => {
			state.isLoading = true;
		});

		builder.addCase(updateOrgChartDepOrder.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(updateOrgChartDepOrder.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default updateOrgChartDepOrderSlice.reducer;
